import { useEffect, useRef } from 'react';

type TLottie = typeof import('lottie-web');

interface UseLottieAnimationProps {
    uid: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    animationData: any;
    loop?: boolean;
    autoplay?: boolean;
}

export const useLottieAnimation = ({
    uid,
    animationData,
    loop = true,
    autoplay = true,
}: UseLottieAnimationProps) => {
    const element = useRef<HTMLDivElement>(null);
    const lottieRef = useRef<TLottie['default'] | null>(null);

    useEffect(() => {
        let isMounted = true;

        import(/* webpackChunkName: "lottie-web" */ 'lottie-web')
            .then((lottie) => {
                if (!isMounted) return;
                
                lottieRef.current = lottie.default || lottie;
                if (element.current) {
                    lottieRef.current.loadAnimation({
                        name: uid,
                        container: element.current,
                        animationData,
                        renderer: 'svg',
                        loop,
                        autoplay,
                    });
                }
            })
            .catch((error) => {
                console.error('Error loading lottie-web', error);
            });

        return () => {
            isMounted = false;
            if (lottieRef.current) {
                lottieRef.current.destroy(uid);
            }
        };
    }, [uid, animationData, loop, autoplay]);

    return { element };
};
